/**
 * engagementcommentreducer.js
 * Created by yonamine on 05/11/2020.
 */
import * as actions from '../../../actions/actiontypes';
import initialstate from '../../initialstate';
import Utility from '../../../util/utilityfunctions';
export function aresFormDataByBodyTypeIdReducer(state = initialstate.aresFormDataByBodyTypeId, action) {
	switch (action.type) {
		case actions.GET_FORM_BODIES_BY_BODYTYPEID:
			if (action) {
				return applyResponse(action.response);
			}
			break;
		default:
			return state;
	}
}

function applyResponse(response) {
	let state;

	state = Utility.normalize(response, undefined);

	return state;
}
